<div class="app-button-multi-select" *ngIf="menuItems?.length">
  <div class="button-group">
    <button
      pButton
      [disabled]="disabled || selectedMenuItem?.disabled"
      (click)="onButtonClick($event)"
      [style]="{ 'min-width': minWidth }"
      
      [pTooltip]="tooltipContent"
      tooltipPosition="left"
    >
      <i
        style="font-size: 15px; color: #000"
        [class]="
          isProcessing
            ? 'fas fa-spinner fa-spin'
            : selectedMenuItem?.icon || 'fa-solid fa-floppy-disk'
        "
        class="button-icon"
      ></i>
      <span
        class="button-text"
        [ngClass]="{
          'app-button-multi-select-disabled': disabled
        }"
      >
        {{ selectedMenuItem?.label || "Select An Option" }}
      </span>
    </button>
    <button
      pButton
      *ngIf="menuItems?.length > 1"
      [disabled]="disabledSelection"
      class="dropdown-button"
      (click)="toggleMenu($event)"
    >
      <i class="fa-regular fa-angle-down"></i>
    </button>
  </div>

  <div class="dropdown-menu" *ngIf="showMenu">
    <div
      *ngFor="let item of menuItems"
      class="menu-item"
      [ngClass]="{ disabled: item.disabled }"
      (click)="onMenuItemSelect(item)"
    >
      <i class="text-link-color" [class]="item.icon || 'fa-solid fa-floppy-disk'" class="menu-icon"></i>
      <p class="menu-label text-link-color">{{ item.label }}</p>
    </div>
  </div>
</div>
